module.exports = __webpack_public_path__ + "static/media/fan coral 0.2.cc3d8e42.svg";